import React, { useState } from 'react';
import { useSprings,interpolate } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import ReviewsSection from '../components/reviews/index';
import { Heading3 } from '../typography/typography';
import ImgMediaCard from '../components/ui-elements/mui-card/index';

// const cards = [
//   'https://upload.wikimedia.org/wikipedia/en/f/f5/RWS_Tarot_08_Strength.jpg',
//   'https://upload.wikimedia.org/wikipedia/en/5/53/RWS_Tarot_16_Tower.jpg',
//   'https://upload.wikimedia.org/wikipedia/en/9/9b/RWS_Tarot_07_Chariot.jpg',
//   'https://upload.wikimedia.org/wikipedia/en/d/db/RWS_Tarot_06_Lovers.jpg',
//   'https://upload.wikimedia.org/wikipedia/en/thumb/8/88/RWS_Tarot_02_High_Priestess.jpg/690px-RWS_Tarot_02_High_Priestess.jpg',
//   'https://upload.wikimedia.org/wikipedia/en/d/de/RWS_Tarot_01_Magician.jpg'
// ]

// These two are just helpers, they curate spring data, values that are later being interpolated into css
const to = i => ({ x: 0, y: i * -4, scale: 1, rot: -10 + Math.random() * 20, delay: i * 100 })
const from = i => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) => `perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`

export default function ReviewsContainer() {
    const [reviews, setReviews] = useState([
        {logo:"/images/fiverr.jpg", name: "jonathangantry", text: "I'm very happy as always with muzamil and I will work with him again.Very professional job"},
        {logo:"/images/fiverr.jpg", name: "tobianthompson", text: "Thank you sooo much!! this is exactly what i needed!"},
        {logo:"/images/fiverr.jpg", name: "motorlifecycle", text: "Thank you for delivering my project. Will be working with you again in the future."},
        {logo:"/images/fiverr.jpg", name: "jonathangantry", text: "I'm very happy with the job. Definitely I will work with you again very soon"},
        {logo:"/images/fiverr.jpg", name: "yonghokim", text: "so fast, and expert knowledge about the work"},
        {logo:"/images/fiverr.jpg", name: "kal_94", text: "Highly Recommended. Outstanding communication.Professional, affordable and quality service.I wish I could give 10 stars, if I could or Deserving of 10 stars."},
        {logo:"/images/fiverr.jpg", name: "subashdev9", text: "I really appriciate his work because he is very flexible and patient. When i said change something he always do what i saying and he never told at once i can't do this blah blah. I will work with him in the future and did great job."},
        {logo:"/images/fiverr.jpg", name: "nareshkosgi", text: "Excellent work. On-time and communication was great."},
        {logo:"/images/fiverr.jpg", name: "drew_porter", text: "I love it. Exactly as I was imagining. I’ll be in touch when we need to build it out more."},
        {logo:"/images/fiverr.jpg", name: "greensoftware", text: "I highly recommend this to everyone, proper work done according to requirements."},
        {logo:"/images/ptcl.jpg", name: "Khalid Ansar(Senior Manager)", text: "Hardworking and talented guy. He made an amazing application which will save a lot of time on daily basis. "},
        {logo:"/images/upwork.jpg", name: "Julie Shamas", text: "Very hard working, fast , attentive and diligent. Very responsive to requests and feedback. Would definitely hire again."},
    ]);
    const [gone] = useState(() => new Set()) // The set flags all the cards that are flicked out
    const [props, set] = useSprings(reviews.length, i => ({ ...to(i), from: from(i) })) // Create a bunch of springs using the helpers above
    // Create a gesture, we're interested in down-state, delta (current-pos - click-pos), direction and velocity
    const bind = useGesture(({ args: [index], down, delta: [xDelta], distance, direction: [xDir], velocity }) => {
        const trigger = velocity > 0.2 // If you flick hard enough it should trigger the card to fly out
        const dir = xDir < 0 ? -1 : 1 // Direction should either point left or right
        if (!down && trigger) gone.add(index) // If button/finger's up and trigger velocity is reached, we flag the card ready to fly out
        set(i => {
        if (index !== i) return // We're only interested in changing spring-data for the current spring
        const isGone = gone.has(index)
        const x = isGone ? (200 + window.innerWidth) * dir : down ? xDelta : 0 // When a card is gone it flys out left or right, otherwise goes back to zero
        const rot = xDelta / 100 + (isGone ? dir * 10 * velocity : 0) // How much the card tilts, flicking it harder makes it rotate faster
        const scale = down ? 1.1 : 1 // Active cards lift up a bit
        return { x, rot, scale, delay: undefined, config: { friction: 50, tension: down ? 800 : isGone ? 200 : 500 } }
        })
        if (!down && gone.size === reviews.length) setTimeout(() => gone.clear() || set(i => to(i)), 600)
    })
    // Now we're just mapping the animated values to our view, that's it. Btw, this component only renders once. :-)
    return (
        <ReviewsSection id="reviews">
        <Heading3>Reviews</Heading3>
            <ReviewsSection.MainContainer>
                {
                    props.map(({ x, y, rot, scale }, i) => (
                        <ReviewsSection.ReviewCardDeck key={i} style={{ transform: interpolate([x, y], (x, y) => `translate3d(${x}px,${y}px,0)`) }}>
                        {/* This is the card itself, we're binding our gesture to it (and inject its index so we know which is which) */}
                        <ReviewsSection.ReviewCard {...bind(i)} style={{ transform: interpolate([rot, scale], trans)}} >
                        <ImgMediaCard
                            src={reviews[i].logo}
                            title={reviews[i].name}
                            text={reviews[i].text}
                            reviews
                            />
                        </ReviewsSection.ReviewCard>
                        </ReviewsSection.ReviewCardDeck>
                    ))
                }
            </ReviewsSection.MainContainer>
        </ReviewsSection>
    ) 
}

